import { datadogRum } from "@datadog/browser-rum";

type RumContext = Record<string, unknown>;

/**
 * Safe wrapper for DataDog RUM calls.
 * Ensures monitoring code never breaks the main application flow.
 */
export const safeDatadogRum = {
  /**
   * Safely track a user action
   */
  addAction(name: string, context?: RumContext): void {
    try {
      datadogRum.addAction(name, context);
    } catch (error) {
      console.warn("[DataDog RUM] Failed to track action:", name, error);
    }
  },

  /**
   * Safely track an error
   */
  addError(error: unknown, context?: RumContext): void {
    try {
      datadogRum.addError(error, context);
    } catch (err) {
      console.warn("[DataDog RUM] Failed to track error:", err);
    }
  },
};
